/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AddonResponseScope = typeof AddonResponseScope[keyof typeof AddonResponseScope];


export const AddonResponseScope = {
  org: 'org',
  seat: 'seat',
} as const;
